import template from './toggle-option.html';

export default angular.module('gm.wealth.common')
  .directive('gmwToggleOption', gmwToggleOption)
  .name;

function gmwToggleOption() {
  'ngInject';

  const directive = {
    link,
    replace: true,
    require: '^ngModel',
    restrict: 'E',
    scope: {
      label: '@',
      value: '=',
    },
    template,
  };
  return directive;

  function link(scope, _element, attrs, ctrl) {
    scope.onClick = onClick;

    function onClick() {
      if (!scope.disabled) {
        ctrl.$setViewValue(scope.value);
      }
    }

    function onValueChange(passed) {
      const value = ctrl.$viewValue;

      scope.active = (value === scope.value);
      return passed;
    }

    attrs.$observe('disabled', () => {
      scope.disabled = attrs.disabled || false;
    });
    scope.$watch(() => scope.value, onValueChange);
    ctrl.$parsers.unshift((modelVal) => {
      scope.active = (modelVal === scope.value);
      return modelVal;
    });
    ctrl.$formatters.unshift((modelVal) => {
      scope.active = (modelVal === scope.value);
      return modelVal;
    });
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/common/directives/toggle-option/toggle-option.js